import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app';
import { ThemeProvider } from './contexts/ThemeContext';
import './app.scss';

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
    <ThemeProvider>
        <App />
    </ThemeProvider>
);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
